


import React, { useState, useEffect, useRef } from "react";

import { VscCheckAll } from "react-icons/vsc";
import Button from "../Button";
import SearchBar from "../SearchBar";
import { Modal } from "../Modal";
import ReactSelect from "react-select";
import Pagination from "../Pagination";
import { supabase } from "../../supabaseClient";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { AsyncPaginate } from "react-select-async-paginate";
import { ShowAllTilesSkeleton } from "../Skeleton";

// Lookup tables (source/castMembers) store names lowercase, but legacy tile rows
// store the Title Case form in the tiles.source/cast array columns. Postgres array
// containment is case-sensitive, so both forms need to be matched.
const toTitleCase = (str) =>
  String(str)
    .split(" ")
    .map((w) => (w ? w[0].toUpperCase() + w.slice(1) : w))
    .join(" ");

function ShowAllTiles({
  selectedTiles,
  setSelectedTiles,
  toggleTileSelection,
  imageField = "poster",
  tileImageOverrides = {},
  setTileImageOverrides,
  imagePickerTile,
  setImagePickerTile,
  getTileImageOptions,
  resolveTileImageUrl,
}) {
  const [searchTiles, setSearchTiles] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [filters, setFilters] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginatedTiles, setPaginatedTiles] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [languageMap, setLanguageMap] = useState({});
  const [allSource, setAllSource] = useState({});
  const [allContentTypes, setAllContentTypes] = useState([]);
  const [allLanguages, setAllLanguages] = useState({});
  const [allDirectors, setAllDirectors] = useState({});
  const [allCastMembers, setAllCastMembers] = useState({});
  const [allGenres, setAllGenres] = useState({});
  const [allImdbIds, setAllImdbIds] = useState([]);
  const [allTitles, setAllTitles] = useState([]);
  const [uniqueCategoryValues, setUniqueCategoryValues] = useState({});

  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [movieData, setMovieData] = useState([]);
  const [allTags, setAllTags] = useState([]);
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState("");
  const [uniquePerCategory, setUniquePerCategory] = useState({});
  const pageSize = 12;
  const minioBaseUrl = "https://images.do.cloudwalker.tv/images/";
  const titleLogoBaseUrl = "https://images.do.cloudwalker.tv/development/";
  const [maxPagesToShow, setMaxPagesToShow] = useState(10);
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const castParam = params.get("cast");


  const STATUS_OPTIONS = [
    { value: "Published", label: "Published" },
    { value: "Draft", label: "Draft" },
    { value: "Universe", label: "Universe" },
    { value: "Unpublished", label: "Unpublished" },
  ];



  const category = [
    { key: "title", label: "Title" },
    // { key: "poster", label: "Poster" },
    // { key: "portrait", label: "Portrait" },
    // { key: "background", label: "Background" },
    { key: "languages", label: "languages" },
    { key: "tags", label: "tags" },
    { key: "imdb_id", label: "imdb_id" },
    { key: "source", label: "source" },
    { key: "genre", label: "Genre" },
    { key: "contentType", label: "ContentType" },
    { key: "year", label: "Year" }, // Fixed typo
    { key: "director", label: "Director" }, // Fixed typo
    { key: "cast", label: "Cast Members" },
    { key: "synopsis", label: "Synopsis" },
    { key: "status", label: "Status" },
  ];


  const PAGE_LIMIT = 30;

  const loadFilterOptions = async (category, search, loadedOptions, { page }) => {
    let table = "";
    let labelKey = "";
    let valueKey = "id";

    switch (category) {
      case "languages":
        table = "languages";
        labelKey = "languages";
        break;
      case "source":
        table = "source";
        labelKey = "source";
        break;
      case "genre":
        table = "genres";
        labelKey = "genres";
        break;
      case "director":
        table = "directors";
        labelKey = "directors";
        break;
      case "cast":
        table = "castMembers";
        labelKey = "castMembers";
        break;
      case "contentType":
        table = "contentType";
        labelKey = "contentType";
        break;
         // ✅ ADD THIS
  case "year":
    table = "year";
    labelKey = "year";
    break;
    case "synopsis": {
  const from = page * PAGE_LIMIT;
  const to = from + PAGE_LIMIT - 1;

  let query = supabase
    .from("tiles")
    .select("synopsis")
    .not("synopsis", "is", null)
    .neq("synopsis", "")
    .range(from, to);

  if (search) {
    query = query.ilike("synopsis", `%${search}%`);
  }

  const { data, error } = await query;

  if (error) {
    console.error(error);
    return { options: [], hasMore: false, additional: { page } };
  }

  const unique = [
    ...new Set((data || []).map((item) => item.synopsis).filter(Boolean)),
  ];

  const options = unique.map((val) => ({
    value: val,
    label: val,
  }));

  return {
    options,
    hasMore: data.length === PAGE_LIMIT,
    additional: { page: page + 1 },
  };
}
    case "title": {
  const from = page * PAGE_LIMIT;
  const to = from + PAGE_LIMIT - 1;

  let query = supabase
    .from("tiles")
    .select("title")
    .not("title", "is", null)
    .neq("title", "")
    .range(from, to);

  if (search) {
    query = query.ilike("title", `%${search}%`);
  }

  const { data, error } = await query;

  if (error) {
    console.error(error);
    return { options: [], hasMore: false, additional: { page } };
  }

  const unique = [
    ...new Set((data || []).map((item) => item.title).filter(Boolean)),
  ];

  return {
    options: unique.map((val) => ({ value: val, label: val })),
    hasMore: data.length === PAGE_LIMIT,
    additional: { page: page + 1 },
  };
}
    case "imdb_id": {
  const from = page * PAGE_LIMIT;
  const to = from + PAGE_LIMIT - 1;

  let query = supabase
    .from("tiles")
    .select("imdb_id")
    .not("imdb_id", "is", null)
    .neq("imdb_id", "")
    .range(from, to);

  if (search) {
    query = query.ilike("imdb_id", `%${search}%`);
  }

  const { data, error } = await query;

  if (error) {
    console.error(error);
    return { options: [], hasMore: false, additional: { page } };
  }

  const unique = [
    ...new Set((data || []).map((item) => item.imdb_id).filter(Boolean)),
  ];

  return {
    options: unique.map((val) => ({ value: val, label: val })),
    hasMore: data.length === PAGE_LIMIT,
    additional: { page: page + 1 },
  };
}
    case "status": {
  const statusOptions = [
    { value: "Published", label: "Published" },
    { value: "Draft", label: "Draft" },
    { value: "Universe", label: "Universe" },
    { value: "Unpublished", label: "Unpublished" },
  ];

  const filtered = search
    ? statusOptions.filter((s) =>
        s.label.toLowerCase().includes(search.toLowerCase())
      )
    : statusOptions;

  return {
    options: filtered,
    hasMore: false,
    additional: { page: 0 },
  };
}
    case "tags": {
  const from = page * PAGE_LIMIT;
  const to = from + PAGE_LIMIT - 1;

  let query = supabase
    .from("tiles")
    .select("tags")
    .not("tags", "is", null)
    .neq("tags", "[]")
    .range(from, to);

  const { data, error } = await query;

  if (error) {
    console.error(error);
    return { options: [], hasMore: false, additional: { page } };
  }

  let all = [];
  (data || []).forEach((row) => {
    try {
      const parsed = JSON.parse(row.tags);
      if (Array.isArray(parsed)) {
        all.push(...parsed);
        return;
      }
    } catch {}
    const clean = row.tags
      .replace(/[\[\]"]/g, "")
      .split(",")
      .map((t) => t.trim())
      .filter(Boolean);
    all.push(...clean);
  });

  let unique = [...new Set(all)].filter(Boolean);

  if (search) {
    unique = unique.filter((t) =>
      t.toLowerCase().includes(search.toLowerCase())
    );
  }

  return {
    options: unique.map((val) => ({ value: val, label: val })),
    hasMore: data.length === PAGE_LIMIT,
    additional: { page: page + 1 },
  };
}
      default:
        return {
          options: [],
          hasMore: false,
          additional: { page: 0 },
        };
    }

    const from = page * PAGE_LIMIT;
    const to = from + PAGE_LIMIT - 1;

    let query = supabase
      .from(table)
      .select(`${valueKey}, ${labelKey}`)
      .range(from, to);

    if (search) {
      query = query.ilike(labelKey, `%${search}%`);
    }

    const { data, error } = await query;

    if (error) {
      console.error(error);
      return { options: [], hasMore: false, additional: { page } };
    }

    // const options = (data || []).map((item) => ({
    //   value: item[valueKey],
    //   label: item[labelKey],
    // }));

    const options = (data || []).map((item) => ({
  // cast/director filters match against the exact name stored on tiles.cast/director,
  // not the uuid — send the name itself as the option value.
  value: category === "year"
    ? String(item.year)
    : (category === "cast" || category === "director")
      ? String(item[labelKey])
      : item[valueKey],
  label: String(item[labelKey]),
}));

    return {
      options,
      hasMore: data.length === PAGE_LIMIT,
      additional: { page: page + 1 },
    };
  };

  const fetchAllPaginated = async (table, columns, pageSize = 500) => {
    let allData = [];
    let from = 0;
    let done = false;

    while (!done) {
      const { data, error } = await supabase
        .from(table)
        .select(columns)
        .range(from, from + pageSize - 1);

      if (error) {
        console.error(`Error fetching ${table}:`, error);
        break;
      }

      if (data.length === 0) {
        done = true;
      } else {
        allData = [...allData, ...data];
        from += pageSize;
      }
    }

    return allData;
  };


  const resolveImage = (tile) => {
    const placeholder = "https://t3.ftcdn.net/jpg/05/04/28/96/360_F_504289605_zehJiK0tCuZLP2MdfFBpcJdOVxKLnXg1.jpg";

    const tryArray = (val) => {
      if (!val) return [];
      if (Array.isArray(val)) return val;
      try {
        const parsed = JSON.parse(val);
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        return [];
      }
    };

    const firstUrl = (field) => {
      const arr = tryArray(tile[field]);
      const src = arr[0];
      if (!src) return null;
      if (src.startsWith("http")) return src;
      const base = field === "titleLogo" ? titleLogoBaseUrl : minioBaseUrl;
      const path = src.startsWith("tiles/") ? src : `tiles/${src}`;
      return base + path;
    };

    // For portrait-type fields: prefer longPortrait, fall back to portrait
    const portraitFields = ["portrait", "longPortrait"];
    if (portraitFields.includes(imageField)) {
      return firstUrl("longPortrait") || firstUrl("portrait") || firstUrl("poster") || placeholder;
    }

    return firstUrl(imageField) || firstUrl("poster") || firstUrl("background") || firstUrl("titleLogo") || placeholder;
  };


  // Fetch languages and sources maps
  useEffect(() => {
    const fetchLanguages = async () => {
      const { data, error } = await supabase
        .from("languages")
        .select("id, languages");

      if (error) {
        console.error("Error fetching languages:", error);
        return;
      }
      const map = {};
      (data || []).forEach((row) => {
        if (row?.id && row?.languages) map[row.id] = row.languages;
      });
      setLanguageMap(map);
    };

    const fetchSources = async () => {
      const { data, error } = await supabase
        .from("source")
        .select("id, source");

      if (error) {
        console.error("Error fetching sources:", error);
        return;
      }
      const map = {};
      (data || []).forEach((row) => {
        if (row?.id && row?.source) map[row.id] = row.source;
      });
      setAllSource(map);
    };

    const fetchContentTypes = async () => {
      const { data, error } = await supabase
        .from("contentType")
        .select("id, contentType");
      if (error) {
        console.error("Error fetching content types:", error);
        return;
      }
      const map = {};
      (data || []).forEach((row) => {
        if (row?.id && row?.contentType) map[row.id] = row.contentType;
      });
      setAllContentTypes(map);
    };


    fetchLanguages();
    fetchSources();
    fetchContentTypes();
  }, []);

  // Debounce search
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchTiles);
      setCurrentPage(1);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchTiles]);


  const toggleAllTiles = () => {
    const allSelected = paginatedTiles.every((tile) =>
      selectedTiles.some((t) => t.id === tile.id)
    );

    if (allSelected) {
      setSelectedTiles((prev) =>
        prev.filter((t) => !paginatedTiles.some((pt) => pt.id === t.id))
      );
    } else {
      const newSelected = [...selectedTiles];
      paginatedTiles.forEach((tile) => {
        if (!newSelected.some((t) => t.id === tile.id)) {
          newSelected.push(tile);
        }
      });
      setSelectedTiles(newSelected);
    }
  };

  const addFilter = () => {
    setFilters((prev) => [
      ...prev,
      {
        category: "",
        value: [],
        subFilterValues: [],
      },
    ]);
  };

  const removeFilter = (index) => {
    setFilters((prev) => prev.filter((_, i) => i !== index));
    setCurrentPage(1);
  };

  const toArray = (val) => {
    if (val == null) return [];
    if (Array.isArray(val)) return val;
    if (typeof val === "string") {
      try {
        const parsed = JSON.parse(val);
        return Array.isArray(parsed) ? parsed : [parsed];
      } catch {
        return [val];
      }
    }
    return [val];
  };

  const getUniqueValues = async (category) => {
    try {



      if (category === "status") {
        return ["Published", "Draft", "Universe", "Unpublished"];
      }

      // ✅ Handle contentType from its own table
      if (category === "contentType") {
        const { data, error } = await supabase
          .from("contentType")
          .select("id, contentType");
        if (error) throw error;

        const values = data.map((row) => row.id);
        return values;
      }



      const { data, error } = await supabase.from("tiles").select(category);
      if (error) throw error;

      let values = data
        .flatMap((row) => toArray(row[category]))
        .filter(Boolean);
      values = Array.from(new Set(values));

      if (category === "languages") {
        values = values.filter((id) => languageMap[id]);

      } else if (category === "source") {
        values = values.filter((id) => allSource[id]);
      }

      return values;
    } catch (error) {
      console.error(`Error fetching unique values for ${category}:`, error);
      return [];
    }
  };

  const categoryList = [
    { key: "title", label: "Title" },
    { key: "languages", label: "Languages" },
    { key: "tags", label: "Tags" },
    { key: "imdb_id", label: "IMDB ID" },
    { key: "source", label: "Source" },
    { key: "contentType", label: "Content Type" },
    { key: "genre", label: "Genre" },
    { key: "year", label: "Year" },
    { key: "director", label: "Director" },
    { key: "cast", label: "Cast Members" },
    { key: "synopsis", label: "Synopsis" },
    { key: "status", label: "Status" },
  ];


  useEffect(() => {
    const updateMaxPages = () => {
      if (window.innerWidth < 640) setMaxPagesToShow(5);   // Mobile
      else if (window.innerWidth < 1024) setMaxPagesToShow(10); // Tablet
      else setMaxPagesToShow(22); // Desktop
    };

    updateMaxPages();
    window.addEventListener("resize", updateMaxPages);
    return () => window.removeEventListener("resize", updateMaxPages);
  }, []);

  const fetchTails = async (page, filters = [], searchQuery = "") => {
    const myFetchId = ++fetchIdRef.current;
    setLoading(true);
    filters = Array.isArray(filters) ? filters : [];

    let supabaseQuery = supabase.from("tiles").select("*", { count: "exact" });

    filters.forEach((filter) => {
      const { category, value } = filter;
      if (!category || !value || value.length === 0) return;

      const ids = value.map((v) => (v?.value !== undefined ? v.value : v));



      if (category === "genre") {

        const matchValues = [];

        ids.forEach(v => {
          const lower = String(v).toLowerCase();
          matchValues.push(lower);

          Object.entries(allGenres).forEach(([uuid, name]) => {
            if (String(uuid).toLowerCase() === lower) matchValues.push(String(name).toLowerCase());
            if (String(name).toLowerCase() === lower) matchValues.push(String(uuid).toLowerCase());
          });
        });

        const unique = [...new Set(matchValues)];

        if (unique.length > 1) {
          const orString = unique.map(v => `genre.cs.{${v}}`).join(",");
          supabaseQuery = supabaseQuery.or(orString);
        } else {
          supabaseQuery = supabaseQuery.contains("genre", [unique[0]]);
        }

        return;
      }


      else if (category === "poster") {
        if (ids.length > 1) {
          const orString = ids.map((v) => `${category}.ilike.%${v}%`).join(",");
          supabaseQuery = supabaseQuery.or(orString);
        } else {
          supabaseQuery = supabaseQuery.ilike(category, `%${ids[0]}%`);
        }

      } else if (category === "languages") {
        const selected = value.map(v => v?.value ?? v); // name or uuid 
        const matchValues = [];
        selected.forEach(v => {
          const lower = String(v).toLowerCase();
          matchValues.push(lower); // match what user selected (uuid or label) 
          // // If user selected readable name → add its UUID as well 
          Object.entries(allLanguages).forEach(([uuid, name]) => {
            if (String(name).toLowerCase() === lower) {
              matchValues.push(uuid.toLowerCase()); // also match uuid
            }
          });
          // If user selected UUID → add its readable name as well 
          Object.entries(allLanguages).forEach(([uuid, name]) => {
            if (String(uuid).toLowerCase() === lower) {
              matchValues.push(String(name).toLowerCase()); // also match name 
            }
          });
        });
        const unique = [...new Set(matchValues)];
        if (unique.length > 1) {
          const orString = unique.map(v => `languages.ilike.%${v}%`).join(","); supabaseQuery = supabaseQuery.or(orString);
        } else {
          supabaseQuery = supabaseQuery.ilike("languages", `%${unique[0]}%`);
        }
      }

      else if (category === "source") {
        // Dropdown sends the uuid, but tiles.source often stores the exact
        // source NAME (Title Case) instead of the uuid — match on all forms.
        const selectedValues = value.map(v => v?.value ?? v); // uuid (or name, defensively)
        const selectedLabels = value.map(v => v?.label); // exact name from the dropdown option

        const matchValues = new Set();

        selectedValues.forEach((v, idx) => {
          const raw = String(v);
          matchValues.add(raw); // covers rows that actually store the uuid

          const name = selectedLabels[idx] ?? allSource[v];
          if (name) {
            matchValues.add(String(name));            // exact name, e.g. "netflix"
            matchValues.add(toTitleCase(String(name))); // e.g. "Netflix"
          }

          // If the selected value is itself a NAME, resolve its uuid too
          Object.entries(allSource).forEach(([uuid, srcName]) => {
            if (String(srcName).toLowerCase() === raw.toLowerCase()) {
              matchValues.add(uuid);
            }
          });
        });

        const unique = [...matchValues];

        if (unique.length > 1) {
          const orString = unique.map(v => `source.cs.{${v}}`).join(",");
          supabaseQuery = supabaseQuery.or(orString);
        } else {
          supabaseQuery = supabaseQuery.contains("source", [unique[0]]);
        }
      }

      else if (category === "contentType") {
        const matchValues = [];

        value.forEach(v => {
          const str = String(v?.value ?? v);

          // always include the selected value (UUID or name)
          matchValues.push(str);

          // if the selected value is NAME → add its exact UUID
          const found = allContentTypes.find(ct => ct.label === str);
          if (found) matchValues.push(found.value);

          // if the selected value is UUID → add its exact NAME
          const foundById = allContentTypes.find(ct => ct.value === str);
          if (foundById) matchValues.push(foundById.label);
        });

        const unique = [...new Set(matchValues)];

        if (unique.length > 1) {
          supabaseQuery = supabaseQuery.or(
            unique.map(v => `contentType.ilike.%${v}%`).join(",")
          );
        } else {
          supabaseQuery = supabaseQuery.ilike("contentType", `%${unique[0]}%`);
        }
      }

      else if (category === "cast") {
        // Dropdown now sends the exact cast member NAME (not the uuid) — tiles.cast
        // stores the name (often Title Case), so match on the name and its Title Case form.
        const selected = value.map(v => v?.value ?? v); // exact name (uuid only if a stale filter/URL param slips through)
        const selectedLabels = value.map(v => v?.label);

        const matchValues = new Set();

        selected.forEach((v, idx) => {
          const raw = String(v);
          matchValues.add(raw);
          matchValues.add(toTitleCase(raw));

          // Backward-compat: resolve a uuid (e.g. from a URL param) to its name
          const name = selectedLabels[idx] ?? allCastMembers[raw];
          if (name) {
            matchValues.add(String(name));
            matchValues.add(toTitleCase(String(name)));
          }
        });

        const unique = [...matchValues];

        if (unique.length > 1) {
          const orString = unique.map(v => `cast.cs.{${v}}`).join(",");
          supabaseQuery = supabaseQuery.or(orString);
        } else {
          supabaseQuery = supabaseQuery.contains("cast", [unique[0]]);
        }
      }
      else if (category === "director") {
        // Dropdown now sends the exact director NAME (not the uuid) — tiles.director
        // stores the name (often Title Case), so match on the name and its Title Case form.
        const selectedValues = value.map(v => v?.value ?? v); // exact name (uuid only if a stale filter/URL param slips through)
        const selectedLabels = value.map(v => v?.label);

        const matchValues = new Set();

        selectedValues.forEach((v, idx) => {
          const raw = String(v);
          matchValues.add(raw);
          matchValues.add(toTitleCase(raw));

          // Backward-compat: resolve a uuid (e.g. from a URL param) to its name
          const name = selectedLabels[idx] ?? allDirectors[raw];
          if (name) {
            matchValues.add(String(name));
            matchValues.add(toTitleCase(String(name)));
          }
        });

        const unique = [...matchValues];

        if (unique.length > 1) {
          const orString = unique.map(v => `director.cs.{${v}}`).join(",");
          supabaseQuery = supabaseQuery.or(orString);
        } else {
          supabaseQuery = supabaseQuery.contains("director", [unique[0]]);
        }
      }
      else if (category === "languages") {
        const names = value
          .map(v => {
            if (!v) return null;
            if (typeof v === "string") return v.toLowerCase();
            if (v.label) return v.label.toLowerCase();
            if (v.value) return v.value.toLowerCase();
            return null;
          })
          .filter(Boolean);

        if (names.length === 0) return;

        if (names.length > 1) {
          const orString = names
            .map(n => `languages.ilike.%[\\\"${n}\\\"]%`)
            .join(",");
          supabaseQuery = supabaseQuery.or(orString);
        } else {
          supabaseQuery = supabaseQuery.ilike("languages", `%[\\\"${names[0]}\\\"]%`);
        }
      }

      else if (category === "tags") {
        const tags = ids.map((v) => v?.label ?? v);

        if (tags.length > 1) {
          // OR condition: any tag matches
          supabaseQuery = supabaseQuery.or(
            tags.map((tag) => `tags.ilike.%${tag}%`).join(",")
          );
        } else {
          supabaseQuery = supabaseQuery.ilike("tags", `%${tags[0]}%`);
        }
      } else {
        // fallback for other plain text fields
        if (ids.length > 1) {
          const orString = ids.map((v) => `${category}.eq.${v}`).join(",");
          supabaseQuery = supabaseQuery.or(orString);
        } else {
          supabaseQuery = supabaseQuery.eq(category, ids[0]);
        }

      }
    });

    // title search
    if (searchQuery) {
      supabaseQuery = supabaseQuery.ilike("title", `%${searchQuery}%`);
    }

    // supabaseQuery = supabaseQuery.order("created_at", { ascending: false });
    supabaseQuery = supabaseQuery.order("created_at", { ascending: false });

    const from = (page - 1) * pageSize;
    const to = page * pageSize - 1;
    supabaseQuery = supabaseQuery.range(from, to);

    const { data, error, count } = await supabaseQuery;

    if (myFetchId !== fetchIdRef.current) {
      // A newer fetch superseded this one — ensure loading is cleared
      setLoading(false);
      return;
    }

    if (error) {
      console.error("Supabase fetch error:", error);
      setMovieData([]);
      setTotalPages(0);
      setLoading(false);
      return;
    }

    setMovieData(data || []);
    setPaginatedTiles(data || []);
    setTotalPages(Math.ceil(count / pageSize) || 0);
    setLoading(false);
  };

  const handleFilterChange = (index, field, value) => {
    const updatedFilters = [...filters];

    if (field === "value") {
      updatedFilters[index][field] = Array.isArray(value) ? value : [value];

      if (updatedFilters[index][field].length === 0) {
        updatedFilters.splice(index, 1);
      }
    } else {
      updatedFilters[index][field] = value;

      if (value === "languages") {
        const languageOptions = Object.entries(allLanguages).map(
          ([id, name]) => ({
            value: id,
            label: name,
          })
        );
        updatedFilters[index].subFilterValues = languageOptions;
      } else if (value === "source") {
        const sourceOptions = Object.entries(allSource).map(([id, name]) => ({
          value: id,
          label: name,
        }));
        updatedFilters[index].subFilterValues = sourceOptions;
      }



      else if (value === "contentType") {
        updatedFilters[index].subFilterValues = allContentTypes; // always array of {value,label}
      }

      else if (value === "director") {
        updatedFilters[index].subFilterValues = Object.entries(allDirectors).map(
          ([id, name]) => ({
            value: id,
            label: name,
          })
        );
      }

      else if (value === "tags") {
        updatedFilters[index].subFilterValues = Array.from(allTags).map(tag => ({
          value: tag,
          label: tag,
        }));

        // console.log("🔥 TAGS OPTIONS:", updatedFilters[index].subFilterValues);

        updatedFilters[index].value = [];
        setFilters(updatedFilters);
        return; // ⛔ Stop here — NO fallback runs!
      }



      else if (value === "status") {
        updatedFilters[index].subFilterValues = STATUS_OPTIONS.map((s) => ({
          value: s.value,
          label: s.label,
        }));
      }
      else if (value === "imdb_id") {
        const imdbValues = uniqueCategoryValues["imdb_id"] || [];

        updatedFilters[index].subFilterValues = imdbValues
          .filter(v => v && v.trim() !== "")
          .map(v => ({
            value: v,
            label: v,
          }));
      }

      else {
        // Fallback for other categories
        updatedFilters[index].subFilterValues =
          uniqueCategoryValues[value] || [];
      }

      // ✅ Make sure at least one empty filter remains
      if (updatedFilters.length === 0) {
        updatedFilters.push({ category: "", value: [], subFilterValues: [] });
      }

      updatedFilters[index].value = []; // Reset selected values
    }

    setFilters(updatedFilters);
  };


  const applyFilters = async () => {
    const validFilters = filters.filter(
      (filter) => filter.category && filter.value.length > 0
    );
    setCurrentPage(1);                    // 🔥 reset page so results show
    fetchTails(1, validFilters); // Filtered data fetch karne ka function call
    setShowFilterModal(false);
  };

  // Remove a single filter value
  const handleRemoveFilter = (category, value) => {
    const updated = filters
      .map((f) =>
        f.category === category
          ? {
            ...f,
            value: Array.isArray(f.value)
              ? f.value.filter((v) => (v.value || v) !== value)
              : [], // force array
          }
          : f
      ) // 🧹 NEW: remove any filter that now has 0 selected values
      .filter((f) => f.value && Array.isArray(f.value) && f.value.length > 0);
    setFilters(updated);
    const params = new URLSearchParams(location.search);
    params.delete(category); // remove this filter param
    navigate(`${location.pathname}?${params.toString()}`);

  };

  // Clear all filters
  const handleClearAll = () => {
    setFilters(filters.map((f) => ({ ...f, value: [] })));
    navigate(location.pathname); // reset URL
  };

  const prevActiveRef = useRef([]);
  const fetchIdRef = useRef(0);


  useEffect(() => {
    const activeFilters = filters.filter(
      (f) => f.category && f.value && f.value.length > 0
    );

    // normalize for comparison (category + sorted values)
    const normalized = activeFilters.map((f) => ({
      category: f.category,
      value: [...f.value].sort(),
    }));

    const prev = prevActiveRef.current;

    const changed =
      prev.length !== normalized.length ||
      prev.some(
        (pf, i) =>
          pf.category !== normalized[i].category ||
          pf.value.join(",") !== normalized[i].value.join(",")
      );

    if (changed) {
      prevActiveRef.current = normalized;
      applyFilters(activeFilters.length > 0 ? activeFilters : []);
    }
  }, [filters]);


  useEffect(() => {
    const fetchData = async () => {
      const params = new URLSearchParams(location.search);
      const castFromUrl = params.get("cast"); // could be name or ID
      const directorFromUrl = params.get("director");
      const languageFromUrl = params.get("languages");
      const genreFromUrl = params.get("genres");
      const sourceFromUrl = params.get("sources");
      const contentTypeFromUrl = params.get("contentType");
      // YEAR
      const yearFromUrl = params.get("year");

      let urlFilters = [...filters]; // start with existing filters


      let query = supabase.from("tiles").select("*");



      // CAST
      if (castFromUrl) {
        const rawCast = decodeURIComponent(castFromUrl).trim();
        const isUUID = /^[0-9a-fA-F-]{36}$/.test(rawCast);

        let castId = null;
        let castName = null;

        if (isUUID) {
          // ✅ If user passed ID, fetch name
          const { data } = await supabase
            .from("castMembers")
            .select("castMembers")
            .eq("id", rawCast)
            .single();

          castId = rawCast;
          castName = data?.castMembers || null;
        } else {
          // ✅ If user passed name, fetch ID
          const { data } = await supabase
            .from("castMembers")
            .select("id")
            .eq("castMembers", rawCast)
            .single();

          castName = rawCast;
          castId = data?.id || null;
        }

        // ✅ Build final list of values to match (no duplicates)
        const castValues = [...new Set([castId, castName].filter(Boolean))];

        // ✅ Update UI filters panel
        const existingCastIndex = urlFilters.findIndex(
          (f) => f.category === "cast"
        );
        if (existingCastIndex > -1) {
          urlFilters[existingCastIndex].value = castValues;
        } else {
          urlFilters.push({ category: "cast", value: castValues });
        }

        // ✅ Apply to query: match ANY of the values
        // cast is stored as array column → use cs filter correctly
        if (castValues.length > 1) {
          query = query.or(castValues.map((v) => `cast.cs.{${v}}`).join(","));
        } else {
          query = query.filter("cast", "cs", `{${castValues[0]}}`);
        }
      }



      if (directorFromUrl) {
        const rawDirector = decodeURIComponent(directorFromUrl).trim();
        const isUUID = /^[0-9a-fA-F-]{36}$/.test(rawDirector);

        let directorId = null;
        let directorName = null;

        if (isUUID) {
          // ✅ If user passed ID, fetch name
          const { data } = await supabase
            .from("directors")
            .select("directors")
            .eq("id", rawDirector)
            .single();

          directorId = rawDirector;
          directorName = data?.directors || null;
        } else {
          // ✅ If user passed name, fetch ID
          const { data } = await supabase
            .from("directors")
            .select("id")
            .eq("directors", rawDirector)
            .single();

          directorName = rawDirector;
          directorId = data?.id || null;
        }

        // ✅ Build final list of values to match (no duplicates)
        const directorValues = [
          ...new Set([directorId, directorName].filter(Boolean)),
        ];

        // ✅ Update UI filters panel
        const existingDirectorIndex = urlFilters.findIndex(
          (f) => f.category === "director"
        );
        if (existingDirectorIndex > -1) {
          urlFilters[existingDirectorIndex].value = directorValues;
        } else {
          urlFilters.push({ category: "director", value: directorValues });
        }

        // ✅ Apply to query: match ANY of the values
        if (directorValues.length > 1) {
          query = query.or(
            directorValues.map((v) => `director.cs.{${v}}`).join(",")
          );
        } else {
          query = query.filter("director", "cs", `{${directorValues[0]}}`);
        }
      }

      // LANGUAGES
      if (languageFromUrl) {
        const existingLangIndex = urlFilters.findIndex(
          (f) => f.category === "languages"
        );
        if (existingLangIndex > -1) {
          urlFilters[existingLangIndex].value = [languageFromUrl];
        } else {
          urlFilters.push({ category: "languages", value: [languageFromUrl] });
        }
      }

      // GENRES
      if (genreFromUrl) {
        const existingGenreIndex = urlFilters.findIndex(
          (f) => f.category === "genre"
        );
        if (existingGenreIndex > -1) {
          urlFilters[existingGenreIndex].value = [genreFromUrl];
        } else {
          urlFilters.push({ category: "genre", value: [genreFromUrl] });
        }
      }

      // SOURCES
      if (sourceFromUrl) {
        const existingSourceIndex = urlFilters.findIndex(
          (f) => f.category === "source"
        );
        if (existingSourceIndex > -1) {
          urlFilters[existingSourceIndex].value = [sourceFromUrl];
        } else {
          urlFilters.push({ category: "source", value: [sourceFromUrl] });
        }
      }

      // CONTENT TYPE
      if (contentTypeFromUrl) {
        const existingCTIndex = urlFilters.findIndex(
          (f) => f.category === "contentType"
        );
        if (existingCTIndex > -1) {
          urlFilters[existingCTIndex].value = [contentTypeFromUrl];
        } else {
          urlFilters.push({
            category: "contentType",
            value: [contentTypeFromUrl],
          });
        }
      }

      if (yearFromUrl) {
        const yearValue = decodeURIComponent(yearFromUrl);
        const isUUID = /^[0-9a-fA-F-]{36}$/.test(yearValue);
        let finalYearValue = yearValue;

        if (isUUID) {
          // fetch readable year from "year" table
          const { data } = await supabase
            .from("year")
            .select("year") // column name inside year table
            .eq("id", yearValue)
            .single();

          if (data?.year) {
            finalYearValue = data.year;
          }
        }

        // Update UI Filter State
        const existingYearIndex = urlFilters.findIndex(
          (f) => f.category === "year"
        );
        if (existingYearIndex > -1) {
          urlFilters[existingYearIndex].value = [finalYearValue];
        } else {
          urlFilters.push({
            category: "year",
            value: [finalYearValue],
          });
        }

        // ✅ Apply to tiles query
        // If UUID was provided originally, allow matching *either* UUID or resolved text year.
        if (isUUID && finalYearValue !== yearValue) {
          query = query.or(`year.eq.${yearValue},year.eq.${finalYearValue}`);
        } else {
          query = query.eq("year", finalYearValue);
        }
      }

      // Apply updated filters if any or existing
      if (
        castFromUrl ||
        directorFromUrl ||
        languageFromUrl ||
        genreFromUrl ||
        sourceFromUrl ||
        contentTypeFromUrl ||
        yearFromUrl || // <--- add this
        filters.length > 0
      ) {
        setFilters(urlFilters);
        fetchTails(currentPage, urlFilters, searchQuery);
      }
    };

    fetchData();
  }, [location.search]);

  const mapIdsToOptions = (ids, options) => {
    if (!ids) return [];
    return ids
      .map((id) => options.find((opt) => opt.value === id))
      .filter(Boolean); // remove nulls if no match
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    // Pass the current filters state to fetchTails
    const activeFilters = filters.filter(
      (filter) => filter.category && filter.value.length > 0
    );
    // fetchTails(page, activeFilters, debouncedSearchQuery);
    fetchTails(page, activeFilters, debouncedSearch);
    console.log("fetchTails CALLED WITH:", filters);
    console.log("SEARCH TERM:", debouncedSearch);
  };

  useEffect(() => {
    if (showFilterModal) {
      fetchTilesData();
    }
  }, [showFilterModal]);

  const fetchTilesData = async () => {
    try {
      const { data, error } = await supabase.from("tiles").select("*");

      if (error) throw error;

      // Extract unique values for each category
      const categoryValues = {};
      category.forEach(({ key }) => {
        categoryValues[key] = Array.from(
          new Set(data.map((item) => item[key]))
        ).filter(Boolean);
      });

      setUniqueCategoryValues(categoryValues);
    } catch (err) {
      console.error("Error fetching tiles data:", err.message);
    }
  };

  useEffect(() => {



    const fetchAllTitles = async () => {
      console.log("📌 fetchAllTitles() called...");

      const { data, error } = await supabase
        .from("tiles")
        .select("id, title")
        .not("title", "is", null)
        .neq("title", "")
        .order("created_at", { ascending: false });

      if (error) {
        console.error("❌ Error fetching titles:", error);
        return;
      }

      console.log("📦 Raw rows fetched from DB:", data?.length ?? 0);

      const titleList = data.map(x => x.title).filter(Boolean);
      console.log("🎯 Titles extracted:", titleList.length);

      const uniqueTitles = [...new Set(titleList)];
      console.log("🧮 Unique titles after Set:", uniqueTitles.length);

      // preview first 30 titles so you can confirm variety
      console.log("🔍 Sample titles:", uniqueTitles.slice(0, 30));

      const formatted = uniqueTitles.map(t => ({
        value: t,
        label: t
      }));

      setAllTitles(formatted);

      console.log("🏁 Final options sent to dropdown:", formatted.length);
    };




    const fetchImdbIds = async () => {
      const { data, error } = await supabase
        .from("tiles")
        .select("imdb_id")
        .not("imdb_id", "is", null)
        .neq("imdb_id", "");

      if (error) {
        console.error("Error fetching IMDb IDs:", error);
        return;
      }

      const imdbList = [...new Set(data.map(x => x.imdb_id))];
      setAllImdbIds(imdbList);
    };



    const fetchGenres = async () => {
      const data = await fetchAllPaginated("genres", "id, genres");

      const genreMap = {};
      data.forEach(g => {
        genreMap[g.id] = g.genres;
      });

      setAllGenres(genreMap);
    };


    const fetchLanguages = async () => {
      const data = await fetchAllPaginated("languages", "id, languages");

      const map = {};
      data.forEach(l => {
        map[l.id] = l.languages;
      });

      setAllLanguages(map);
    };


    const fetchTags = async () => {
      // console.log("⚡ fetchTags STARTED");

      const { data, error } = await supabase
        .from("tiles")
        .select("tags")
        .not("tags", "is", null)  // 🔥 CRITICAL - only non-null tags
        .gt("tags", "[]")         // 🔥 NEW - exclude empty "[]"
        .limit(1000);

      if (error) {
        console.error("❌ Error:", error);
        setAllTags(["hell", "ui"]); // fallback
        return;
      }

      // console.log("📊 Found rows with tags:", data.length); // should be ~3/

      let all = [];
      data.forEach(row => {
        const raw = row.tags;
        // console.log("🔍 RAW TAG:", raw); // SEE: "[\"hell\",\"ui\"]"

        // JSON.parse your exact format
        try {
          const parsed = JSON.parse(raw);  // ["hell","ui"]
          if (Array.isArray(parsed)) {
            all.push(...parsed);
            return;
          }
        } catch (e) {
          // console.log("🟨 JSON fail:", raw);
        }

        // Bulletproof fallback
        const clean = raw
          .replace(/[\[\]"]/g, '')  // "hell,ui"
          .split(',')
          .map(t => t.trim())
          .filter(Boolean);

        all.push(...clean);
      });

      const unique = [...new Set(all)];
      // console.log("🎯 FINAL TAGS:", unique);  // ["hell", "ui", "hi hello"]
      // console.log("🧮 TOTAL:", unique.length);

      setAllTags(unique);
    };


    const fetchSources = async () => {
      const data = await fetchAllPaginated("source", "id, source");

      const map = {};
      data.forEach(s => {
        map[s.id] = s.source;
      });

      setAllSource(map);
    };


    const fetchCastMembers = async () => {
      const data = await fetchAllPaginated("castMembers", "id, castMembers");

      const map = {};
      data.forEach(c => {
        map[c.id] = c.castMembers;
      });

      setAllCastMembers(map);
    };

    const fetchDirectors = async () => {
      const data = await fetchAllPaginated("directors", "id, directors");

      const map = {};
      data.forEach(d => {
        map[d.id] = d.directors;
      });

      setAllDirectors(map);
    };

    const fetchContentTypes = async () => {
      const data = await fetchAllPaginated("contentType", "id, contentType");

      const formatted = data.map(ct => ({
        value: ct.id,
        label: ct.contentType,
      }));

      setAllContentTypes(formatted);
    };


    fetchGenres();
    fetchContentTypes();
    fetchSources();
    fetchLanguages();
    fetchCastMembers();
    fetchDirectors();
    //  console.log("🏁 Calling fetchTags now");  // debug
    fetchTags();
    fetchImdbIds();
    fetchAllTitles();

  }, []);

  useEffect(() => {
    const activeFilters = filters.filter(
      (f) => f.category && f.value.length > 0
    );

    // add castParam if needed
    if (castParam && !activeFilters.some((f) => f.category === "cast")) {
      activeFilters.push({ category: "cast", value: [castParam] });
    }

    fetchTails(currentPage, activeFilters, debouncedSearch);
  }, [currentPage, filters, castParam, debouncedSearch]);


  return (
    <div className="p-4 bg-white h-full flex flex-col overflow-hidden">
      {/* <h2 className="text-xl font-bold mb-4 text-center">All Tiles</h2> */}
      <div className="mb-4 flex flex-wrap items-center gap-4 justify-between">
        <div className="flex flex-wrap items-center gap-4">
          <Button
            variant={paginatedTiles.every((tile) =>
              selectedTiles.some((t) => t.id === tile.id)
            ) ? "danger" : "success"}
            onClick={toggleAllTiles}
            className="px-4 py-1 text-sm flex items-center gap-3"
          >
            <VscCheckAll />
            {paginatedTiles.every((tile) =>
              selectedTiles.some((t) => t.id === tile.id)
            ) ? "Uncheck Page" : "Check Page"}
          </Button>

          <Button
            variant="primary"
            onClick={() => setShowFilterModal(true)}
            className="px-4 py-1 text-sm flex items-center gap-3"
          >
            Filter
          </Button>
        </div>

        <div className="w-full sm:w-auto md:w-1/3">
          <SearchBar
            value={searchTiles}
            onChange={(e) => setSearchTiles(e.target.value)}
            placeholder="Search Tiles"
          />
        </div>
      </div>

      {filters.some((f) => f.value && f.value.length > 0) && (
        <div className="flex flex-wrap items-center gap-2 mb-4">
          <span className="font-semibold text-gray-700">Filters:</span>
          {filters.flatMap((f) =>
            (Array.isArray(f.value) ? f.value : [f.value]).map((val, i) => {
              const id = val?.value || val;
              let displayValue = id;

              if (f.category === "languages") {
                displayValue = languageMap?.[id] || id;
              } else if (f.category === "source") {
                displayValue = allSource?.[id] || id;
              }
              //               else if (f.category === "contentType") {
              //   displayValue = allContentTypes?.[id] || id;

              // }

              else if (f.category === "contentType") {
                const found = allContentTypes.find(ct => ct.value === id);
                displayValue = found?.label || id;
              }

              else if (f.category === "genre") {
                displayValue = allGenres?.[id] || id;
                console.log("Display Value ==>",displayValue);
              } else if (f.category === "director") {
                displayValue = allDirectors?.[id] || id;
              } else if (f.category === "cast") {
                displayValue = allCastMembers?.[id] || id;
              }

              return (
                <div
                  key={`${f.category}-${id}-${i}`}
                  className="flex items-center gap-1 bg-gray-200 px-3 py-1 rounded-full text-sm text-gray-700"
                >
                  <span>
                    {f.category}: {displayValue}
                  </span>
                  <button
                    onClick={() => handleRemoveFilter(f.category, id)}
                    className="ml-1 text-gray-600 hover:text-red-600"
                  >
                    ✕
                  </button>
                </div>
              );
            })
          )}
          <button
            onClick={handleClearAll}
            className="ml-2 text-sm text-red-600 hover:underline"
          >
            Clear All
          </button>
        </div>
      )}

      {showFilterModal && (
        <Modal
          customClasses="max-w-md w-full bg-white"
          showModal={showFilterModal}
          setShowModal={setShowFilterModal}
        >
          <div className="p-6 overflow-hidden">
            <h2 className="text-xl font-semibold mb-4 text-gray-800">Filter Tiles</h2>
            <div className="space-y-4">
              {filters.length > 0 &&
                filters.map((filter, index) => (
                  <div key={index} className="space-y-2">
                    {/* Category Selector */}
                    <ReactSelect
                      className="w-full"
                      classNamePrefix="react-select"
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 999 }),
                      }}
                      options={category.map((f) => ({
                        value: f.key,
                        label: f.label,
                      }))}
                      value={category.find((f) => f.key === filter.category)}
                      onChange={(selectedOption) =>
                        handleFilterChange(
                          index,
                          "category",
                          selectedOption?.value,
                        )
                      }
                      placeholder="Select Field"
                      isSearchable
                    />
                    {filter.category && (
                      <AsyncPaginate
                        isMulti
                        classNamePrefix="react-select"
                        key={filter.category} // reset when category changes

                        value={filter.value.map((val) => ({
                          value: val,
                          label:
                            filter.category === "languages"
                              ? allLanguages[val] || val
                              : filter.category === "source"
                                ? allSource[val] || val
                                : filter.category === "contentType"
                                  ? allContentTypes.find((c) => c.value === val)?.label || val
                                  : filter.category === "director"
                                    ? allDirectors[val] || val
                                    : filter.category === "cast"
                                      ? allCastMembers[val] || val
                                      : filter.category === "genre"
                                      
                                        ? allGenres[val] || val
                                          : filter.category === "year"
    ? String(val)
                                        : val,
                        }))}

                        loadOptions={(search, loadedOptions, additional) =>
                          loadFilterOptions(
                            filter.category,
                            search,
                            loadedOptions,
                            additional || { page: 0 }
                          )
                        }

                        additional={{ page: 0 }}

                        onChange={(selectedOptions) => {
                          const selectedValues = selectedOptions
                            ? selectedOptions.map((opt) => opt.value)
                            : [];
                          handleFilterChange(index, "value", selectedValues);
                        }}

                        placeholder={`Select ${filter.category}`}
                        isSearchable
                        debounceTimeout={500}

                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 999 }),
                        }}
                      />
                    )}

                    {/* Remove Filter Button */}
                    <button
                      className="mt-2 hover:underline text-sm text-gray-600"
                      onClick={() => removeFilter(index)}
                    >
                      Remove Filter
                    </button>
                  </div>
                ))}

              {/* Add Filter Button */}
              <Button
                variant="primary"
                onClick={addFilter}
                className="mt-2  text-white hover:underline text-sm"
              >
                + Add Filter
              </Button>
            </div>

            <div className="mt-4 flex justify-end">
              <Button
                variant="secondary"
                onClick={() => setShowFilterModal(false)}
                className="mr-2"
              >
                Cancel
              </Button>
              <Button variant="primary" onClick={applyFilters}>
                Apply Filters
              </Button>
            </div>
          </div>
        </Modal>
      )}

      <div className="flex-1 overflow-y-auto min-h-0">
      {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
       */}
      <div className="grid grid-cols-4 gap-4">
        {loading ? (
          <div className="col-span-4">
            <ShowAllTilesSkeleton count={24} />
          </div>
        ) : paginatedTiles.length > 0 ? (
          paginatedTiles.map((tile) => {
            const isSelected = selectedTiles.some((t) => t.id === tile.id);
            const imageOptions = getTileImageOptions ? getTileImageOptions(tile, imageField) : [];
            const chosenImage = tileImageOverrides[tile.tid] || null;
            const isPickerOpen = imagePickerTile === tile.tid;
            const previewSrc = chosenImage && resolveTileImageUrl
              ? resolveTileImageUrl(chosenImage, imageField)
              : null;

            let imagePath = "";
            try {
              let bg = tile.background;

              // if backend returns single url string instead of array
              if (typeof bg === "string" && !bg.startsWith("[") && (bg.startsWith("http") || bg.includes("."))) {
                imagePath = bg; // direct URL / path
              } else {
                // parse JSON if stringified array
                bg = Array.isArray(bg) ? bg : JSON.parse(bg || "[]");
                imagePath = bg[0] || "";
              }

              // ensure full URL
              if (imagePath && !imagePath.startsWith("http")) {
                imagePath = `${minioBaseUrl}${imagePath}`;
              }
            } catch {
              imagePath = "";
            }


            return (
              <div
                key={tile.id}
                onClick={() => toggleTileSelection(tile)}
                className={`relative bg-slate-50 rounded-lg p-4 border-2 transform transition duration-150 cursor-pointer ${isSelected ? "border-green-600" : "border-gray-200"
                  } hover:shadow-md`}
              >
                {isSelected && (
                  <div className="absolute top-2 right-2 bg-green-600 text-white text-xs w-6 h-6 flex items-center justify-center rounded-full">
                    {selectedTiles.findIndex((t) => t.id === tile.id) + 1}
                  </div>
                )}

                <div className="relative flex flex-col items-center w-full">
                  <img
                    src={previewSrc || resolveImage(tile)}
                    alt=""
                    className="w-full h-48 object-cover rounded-md mb-2 bg-gray-100"
                    onError={(e) => { e.currentTarget.src = ""; e.currentTarget.style.display = "none"; }}
                  />

                  {/* Image preview / pick — choose which uploaded image to pin
                      for this tile before (or after) adding it to the row. */}
                  {imageOptions.length > 1 && (
                    <button
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        setImagePickerTile?.(isPickerOpen ? null : tile.tid);
                      }}
                      className="mb-1 text-[11px] text-blue-600 hover:underline"
                    >
                      {isPickerOpen ? "Hide images" : `Pick image (${imageOptions.length})`}
                    </button>
                  )}
                  {isPickerOpen && imageOptions.length > 1 && (
                    <div
                      className="w-full mb-2 p-2 bg-white border border-gray-200 rounded-lg shadow-sm"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <p className="text-[11px] font-semibold text-gray-500 mb-1.5">
                        Choose image
                      </p>
                      <div className="grid grid-cols-3 gap-2">
                        {imageOptions.map((path, i) => {
                          const isChosen = chosenImage === path;
                          return (
                            <button
                              key={i}
                              type="button"
                              onClick={() => {
                                setTileImageOverrides?.((prev) => ({ ...prev, [tile.tid]: path }));
                                setImagePickerTile?.(null);
                              }}
                              className={`relative h-16 rounded-md overflow-hidden border-2 bg-gray-100 ${isChosen ? "border-blue-500 ring-2 ring-blue-200" : "border-gray-200 hover:border-blue-300"}`}
                            >
                              <img
                                src={resolveTileImageUrl(path, imageField)}
                                alt=""
                                className="w-full h-full object-cover"
                              />
                              {isChosen && (
                                <span className="absolute top-0.5 right-0.5 bg-blue-500 rounded-full p-0.5">
                                  <VscCheckAll className="text-white" size={9} />
                                </span>
                              )}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  )}
                  <div className="w-full flex items-start justify-start flex-wrap">
                    {/* TITLE */}
                    <h3 className="text-sm font-semibold text-gray-800 r">
                      {tile.title}
                    </h3>

                    {/* SOURCE */}
                    <div className="text-xs mt-1 w-full">
                      <span className="font-semibold text-gray-800">Source: </span>
                      <span className="text-gray-500">
                        {(() => {
                          try {
                            if (!Array.isArray(tile.source)) return "N/A";

                            const mapped = tile.source
                              .map((id) => allSource[id] || id)
                              .filter(Boolean);

                            return mapped.length ? mapped.join(", ") : "N/A";
                          } catch {
                            return "N/A";
                          }
                        })()}
                      </span>
                    </div>

                    {/* LANGUAGES */}
                    <div className="text-xs w-full">
                      <span className="font-semibold text-gray-800">Languages: </span>
                      <span className="text-gray-500">
                        {(() => {
                          try {
                            const raw = tile.languages;
                            const arr =
                              typeof raw === "string"
                                ? JSON.parse(raw)
                                : Array.isArray(raw)
                                  ? raw
                                  : [];

                            const mapped = arr
                              .map((id) => languageMap[id] || id)
                              .filter(Boolean);

                            return mapped.length ? mapped.join(", ") : "N/A";
                          } catch {
                            return "N/A";
                          }
                        })()}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <p className="text-gray-600">No tiles available.</p>
        )}
      </div>

      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          maxPagesToShow={maxPagesToShow}
        />
      )}
      </div>{/* end scrollable area */}
    </div>
  );
}

export default ShowAllTiles;